<dx-select-box valueExpr="id" displayExpr="title" [dataSource]="queueBatches$ | async"
	(onValueChanged)="onValueChanged($event)">
</dx-select-box>


<dx-data-grid id="gridContainer" [dataSource]="queueBatchItems$ | async" [showBorders]="true" [remoteOperations]="true">
	<dxo-paging [pageSize]="15"></dxo-paging>
	<dxi-column dataField="id" [width]=60></dxi-column>
	<dxi-column dataField="objectId" [width]=100></dxi-column>
	<dxi-column cellTemplate="queueBatchItemStatusCellTemplate" dataField="status"></dxi-column>
	<dxi-column dataField="creationDate" format="dd/MM/yyyy HH:mm" dataType="datetime"></dxi-column>

	<div *dxTemplate="let data of 'queueBatchItemStatusCellTemplate'">
		<div>{{getEnumStringValueQueueBatchItemStatus(data.data.status)}}</div>
	</div>
</dx-data-grid>
